<script setup>
</script>

<template>
    <div class="absolute inset-0 flex flex-col gap-3 justify-center items-center bg-white text-black text-center">
        <h1 class="text-5xl font-bold">{{ $t('error.somethingWentWrong') }}</h1>
        <router-link class="text-2xl underline" :to="{'name': 'Dashboard Page'}">{{ $t('error.backToDashboard') }}</router-link>
    </div>
</template>